import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import List from './List';
import Add from './Add';
import Detail from './Detail';

export default function MonitorProfileSettings() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/`} exact component={List} />
      <Route path={`${path}/add`} exact component={Add} />
      <Route path={`${path}/:monitorProfileId`} exact component={Detail} />
    </Switch>
  );
}
